module.exports = __webpack_public_path__ + "static/img/productu04.075fe1f2.png";